module.exports = __webpack_public_path__ + "static/img/8.7ca850a1.jpeg";